import MainLayout from "@/components/layout/admin/MainLayout.vue";
// import Pagination from "laravel-vue-pagination";
import moment from 'moment';
import axios from "axios";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';

export default {
    name: "AdminApplicantDetail",
    components: {
        MainLayout,
        // Pagination
        AdvancedLaravelVuePaginate
    },

    data() {
        return {
            applicant: {
                name: "",
                email: "",
                address: "",
                phone_number: "",
                gender: ""
            },
            isUpdateApplicant: false,
            resumeList: {},
            resumeListLength: {},
            applyList: {},
            apply: {
                job_delete: ""
            }
        };
    },

    methods: {
        getApplicantDetail() {
            axios.get("admin/applicant/detail/" + this.$route.params.id)
                .then(response => {
                    this.applicant = response.data;
                })
                .catch(error => {
                    console.log("Applicant Detail API Error", error);
                });
        },

        getResume() {
            axios.get("/applicant/resume/list/" + this.$route.params.id)
                .then(response => {
                    this.resumeList = response.data;
                    this.resumeListLength = this.resumeList.length;
                })
                .catch(error => {
                    console.log("Resume List API error:::::>", error.response.data);
                });
        },

        getApplyList(page = 1) {
            axios.get("/apply/list/" +  this.$route.params.id + "?page=" + page)
                .then(response => {
                    this.applyList = response.data;
                })
                .catch(error => {
                    console.log("Apply List API Error", error);
                });
        },

        confirmDelete(id) {
            if (window.confirm("Are you sure?")) {
                this.deleteResume(id);
            } else {
                console.log("no");
            }
        },

        deleteResume(id) {
            axios.delete("/applicant/resume/delete/" + id)
                .then(response => {
                    this.posts = response.data;
                    this.getResume();
                })
                .catch(error => {
                    this.$notification.error("Resume Delete Failed", {
                        timer: 3,
                        position: 'bottomCenter'
                    });
                    console.log(error);
                });
        },

        downloadResumePdf(id) {
            axios({
                url: axios.defaults.baseURL +"applicant/resume/download/" + id,
                method: "GET",
                responseType: "blob"
            })
            .then((response) => {
                var today = new Date();
                var date = today.getFullYear() + '_' + (today.getMonth() + 1) + '_' + today.getDate();
                var cvName = this.applicant.name + '_' + id + '_' + date + '_CV.pdf';
                var url = window.URL.createObjectURL(new Blob([response.data]));
                var link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', cvName);
                document.body.appendChild(link);
                link.click();
            })
            .catch((error) => {
                console.log("Resume Download API error:::::>", error.response);
            });
        }
    },

    mounted() {
        this.getApplicantDetail();
        this.getResume();
        this.getApplyList();
    },

    filters: {
        setMoment: function (value) {
            return moment(value).format("Do MMMM, YYYY");
        }
    }
};